<template>
  <div>
    <div class="loop-tbl" v-for="(item, index) in questions" :key="item.QST_NO">
    <!-- 객관식 (라디오 버튼) -->
    <div class="form-section mt-32" v-if="item.INFOCD === getRadioCode">
      <h3 class="section-title">추가 입력 내용{{ item.QST_NO }} <span class="must">*</span></h3>
      <div class="table-wrap no-line-mg">
        <table class="table-body-only">
          <caption>추가입력내용 테이블{{ item.QST_NO }}</caption>
          <colgroup class="pc-cell">
            <col style="width: 160px;" />
            <col />
          </colgroup>
          <colgroup class="mo-cell">
            <col style="width: 88px;" />
            <col />
          </colgroup>
          <tbody>
            <tr>
              <th>질문</th>
              <td>{{ item.QST }}</td>
            </tr>
            <tr>
              <th>답변</th>
              <td>
                <div class="radio-group">
                  <label class="radio-item" :for="'radio_' + item.QST_NO + '_' + radioIndex" v-for="(answer, radioIndex) in getOptions(item.SELECTABLE_OPTIONS)" :key="radioIndex">
                    <input type="radio" :id="'radio_' + item.QST_NO + '_' + radioIndex" class="sr-only" :name="'radio_group_' + item.QST_NO" :value="answer.trim()" v-model="item.ANSWER" :disabled="isDisabled" title="선택 선택">
                    <span class="custom-radio"></span>
                    {{ answer }}
                  </label>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- 체크형 (체크박스) -->
    <div class="form-section mt-32" v-if="item.INFOCD === getCheckboxCode">
      <h3 class="section-title">추가 입력 내용{{ item.QST_NO }}</h3>
      <div class="table-wrap no-line-mg">
        <table class="table-body-only">
          <caption>추가입력내용 테이블{{ item.QST_NO }}</caption>
          <colgroup class="pc-cell">
            <col style="width: 160px;" />
            <col />
          </colgroup>
          <colgroup class="mo-cell">
            <col style="width: 88px;" />
            <col />
          </colgroup>
          <tbody>
            <tr>
              <th>질문</th>
              <td>{{ item.QST }}</td>
            </tr>
            <tr>
              <th>답변</th>
              <td>
                <div class="check-wrap" v-for="(option, checkIndex) in getOptions(item.SELECTABLE_OPTIONS)" :key="checkIndex">
                  <input type="checkbox" class="sr-only" :id="'check' + index" :value="option" true-value="Y" false-value="N" :disabled="isDisabled" :checked="isChecked(option, item.ANSWER)" title="선택 선택" />
                  <label :for="'check' + index"><span>{{ option }}</span></label>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- 단문형 -->
    <div class="form-section mt-32" v-if="item.INFOCD === getShortTextCode">
      <h3 class="section-title">추가 입력 내용{{ item.QST_NO }}</h3>
      <div class="table-wrap no-line-mg">
        <table class="table-body-only">
          <caption>추가입력내용 테이블{{ item.QST_NO }}</caption>
          <colgroup class="pc-cell">
            <col style="width: 160px;" />
            <col />
          </colgroup>
          <colgroup class="mo-cell">
            <col style="width: 88px;" />
            <col />
          </colgroup>
          <tbody>
            <tr>
              <th>질문</th>
              <td>{{ item.QST }}</td>
            </tr>
            <tr>
              <th>답변</th>
              <td>
                <div class="input-area">
                  <input type="text" placeholder="답변을 입력해 주세요." v-model="item.ANSWER" :disabled="isDisabled" title="답변(단문형)">
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- 장문형 -->
    <div class="form-section mt-32" v-if="item.INFOCD === getLongTextCode">
      <h3 class="section-title">추가 입력 내용{{ item.QST_NO }}</h3>
      <div class="table-wrap no-line-mg">
        <table class="table-body-only">
          <caption>추가입력내용 테이블{{ item.QST_NO }}</caption>
          <colgroup class="pc-cell">
            <col style="width: 160px;" />
            <col />
          </colgroup>
          <colgroup class="mo-cell">
            <col style="width: 88px;" />
            <col />
          </colgroup>
          <tbody>
            <tr>
              <th>질문</th>
              <td>{{ item.QST }}</td>
            </tr>
            <tr>
              <th>답변</th>
              <td>
                <div class="input-area">
                  <textarea type="text" placeholder="답변을 입력해 주세요." v-model="item.ANSWER" :disabled="isDisabled" title="답변(장문형)" name="answer-sentence"></textarea>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AdditionalQuestions',
  props: {
    questions: {
      type: Array,
      default: () => []
    },
    annKindType: {
      type: String,
      default: 'IN'
    },
    isDisabled: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    getRadioCode() {
      return this.annKindType === 'JB' ? 'JB34004' : 'IN34004';
    },
    getCheckboxCode() {
      return this.annKindType === 'JB' ? 'JB34003' : 'IN34003';
    },
    getShortTextCode() {
      return this.annKindType === 'JB' ? 'JB34002' : 'IN34002';
    },
    getLongTextCode() {
      return this.annKindType === 'JB' ? 'JB34001' : 'IN34001';
    }
  },
  methods: {
    getOptions(options) {
      if (!options || typeof options !== 'string') return [];
      return options.split(',');
    },
    isChecked(option, answers) {
      if (!answers || typeof answers !== 'string') return false;
      return answers.split(',').filter((answer) => answer === option).length > 0;
    },
  },
};
</script>



// WEBPACK FOOTER //
// AdditionalQuestions.vue?6214b4cd